// extracted by css-extract-rspack-plugin
export default {"container":"RestoreHistoryButton-module__container__B0jJR","iconButton":"RestoreHistoryButton-module__iconButton__EDNPV","button":"RestoreHistoryButton-module__button__APY69"};